import { z } from 'zod';
import { offerRequestBuildingTypeSchema } from '../../offer-request-management/buildingType.js';
import { offerRequestProjectSizeSchema } from '../../offer-request-management/projectSize.js';
import { offerRequestReportStatusSchema } from '../../offer-request-management/reportStatus.js';
import { offerRequestTimingGroupSchema } from '../../offer-request-management/timingGroup.js';
import { partnerCockpitOfferRequestCreditsSchema, partnerCockpitOfferRequestLanguageSchema, } from './offerRequests.js';
export const offerRequestSortKeySchema = z.enum(['newest', 'oldest']);
export const offerRequestSegmentSchema = z.enum(['new', 'open']);
const repeated = (element) => z.preprocess((value) => (typeof value === 'string' ? value.split(',').filter((entry) => entry.length > 0) : (value ?? [])), z.array(element));
export const partnerCockpitOfferRequestsQuerySchema = z.object({
    segment: offerRequestSegmentSchema,
    start: z.coerce.number().int().min(0).default(0),
    pageSize: z.coerce.number().int().min(1).max(100).default(10),
    sort: offerRequestSortKeySchema.default('newest'),
    search: z.string().optional(),
    dateFrom: z.iso.date().optional(),
    dateTo: z.iso.date().optional(),
    timingGroups: repeated(offerRequestTimingGroupSchema),
    projectSizes: repeated(offerRequestProjectSizeSchema),
    credits: repeated(z.coerce.number().pipe(partnerCockpitOfferRequestCreditsSchema)),
    languages: repeated(partnerCockpitOfferRequestLanguageSchema),
    buildingTypes: repeated(offerRequestBuildingTypeSchema),
    statuses: repeated(offerRequestReportStatusSchema),
});
